const functions = {
    availableMethods() {
        return [
            'updateOne'
        ];
    }
};

export default functions;
